import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';


const firebaseConfig = {
   appId: "1:79410127734:web:11f761dd8dc24b37a9d057",
   apiKey: "AIzaSyBHLBYu7KPgJyJ3bKySCIv3iPC_lAF6Jq4",
   projectId: "screenproof-c3c7f",
   authDomain: "screenproof-c3c7f.firebaseapp.com",
   databaseURL: "https://screenproof-c3c7f.firebaseio.com",
   measurementId: "G-ZGXFW6CXVD",
   storageBucket: "screenproof-c3c7f.appspot.com",
   messagingSenderId: "79410127734"
};

const firebaseService = {
   init() {
      firebase.initializeApp(firebaseConfig);
   },

   async loginWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      return await firebase.auth().signInWithPopup(provider);
   },

   async loginWithFacebook() {
      const provider = new firebase.auth.FacebookAuthProvider();
      return await firebase.auth().signInWithPopup(provider);
   },

   logOut() {
      firebase.auth().signOut();
   },

   async verifyAuth() {
      return new Promise(resolve => {
         firebase.auth().onAuthStateChanged((user) => {
            resolve(user);
         });
      });
   },

   registerReport(data) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         data.created_at = firebase.firestore.Timestamp.fromDate(new Date());
         data.updated_at = firebase.firestore.Timestamp.fromDate(new Date());
         db.collection('reports').add(data).then((res) => {
            data.id = res.id;
            resolve(data);
         }).catch((err) => {
            reject(err);
         });
      });
   },

   fetchReports(id) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         let reports = [];
         db.collection('reports').get().then((querySnapshot) => {
            let result = querySnapshot.docs.filter((snap) => snap.data().uid === id && snap.data().type !== 'PICSCAN');
            result.sort((a, b) => a.data().created_at.toString().localeCompare(b.data().created_at));
            result.reverse();
            result.forEach((doc) => {
               reports.push({
                  'id': doc.id,
                  'uid': doc.data().uid,
                  'type': doc.data().type,
                  'user': doc.data().user,
                  'email': doc.data().email,
                  'source': doc.data().source,
                  'fullpage': doc.data().fullpage,
                  'source_id': doc.data().source_id,
                  'sign_font': doc.data().sign_font,
                  'sign_sign': doc.data().sign_sign,
                  'sign_name': doc.data().sign_name,
                  'blockchain': doc.data().blockchain,
                  'created_at': doc.data().created_at,
                  'activate_js': doc.data().activate_js,
                  'captured_file': doc.data().captured_file,
                  'all_signatures': doc.data().all_signatures,
                  'transaction_hash': doc.data().transaction_hash,
                  'captured_file_id': doc.data().captured_file_id,
                  'captured_file_hash': doc.data().captured_file_hash
               });
            });
            resolve(reports);
         }).catch((err) => {
            reject(err);
         })
      });
   },

   fetchAnalysis(id) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         let reports = [];
         db.collection('reports').get().then((querySnapshot) => {
            let result = querySnapshot.docs.filter((snap) => snap.data().uid === id && snap.data().type === 'PICSCAN');
            result.sort((a, b) => a.data().created_at.toString().localeCompare(b.data().created_at));
            result.reverse();
            result.forEach((doc) => {
               reports.push({
                  'id': doc.id,
                  'uid': doc.data().uid,
                  'type': doc.data().type,
                  'user': doc.data().user,
                  'email': doc.data().email,
                  'source': doc.data().source,
                  'fullpage': doc.data().fullpage,
                  'source_id': doc.data().source_id,
                  'sign_font': doc.data().sign_font,
                  'sign_sign': doc.data().sign_sign,
                  'sign_name': doc.data().sign_name,
                  'blockchain': doc.data().blockchain,
                  'created_at': doc.data().created_at,
                  'activate_js': doc.data().activate_js,
                  'captured_file': doc.data().captured_file,
                  'all_signatures': doc.data().all_signatures,
                  'transaction_hash': doc.data().transaction_hash,
                  'captured_file_id': doc.data().captured_file_id,
                  'captured_file_hash': doc.data().captured_file_hash
               });
            });
            resolve(reports);
         }).catch((err) => {
            reject(err);
         })
      });
   },

   saveInvitation(data, index, report_id) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         data.index = index;
         data.report_id = report_id;
         data.created_at = firebase.firestore.Timestamp.fromDate(new Date());
         data.updated_at = firebase.firestore.Timestamp.fromDate(new Date());
         db.collection('invitations').add(data).then(() => {
            resolve(true);
         }).catch((err) => {
            reject(err);
         });
      });
   },

   fetchInvitation(invid) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         let reports = [];
         db.collection('invitations').get().then((querySnapshot) => {
            let result = querySnapshot.docs.filter((snap) => snap.data().inv_id === invid);
            result.forEach((doc) => {
               reports.push({
                  'id': doc.id,
                  'email': doc.data().email,
                  'index': doc.data().index,
                  'status': doc.data().status,
                  'inv_id': doc.data().inv_id,
                  'report_id': doc.data().report_id
               });
            });
            resolve(reports[0]);
         }).catch((err) => {
            reject(err);
         })
      });
   },

   fetchAllInvitation(report_id) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         let reports = [];
         db.collection('invitations').get().then((querySnapshot) => {
            let result = querySnapshot.docs.filter((snap) => snap.data().report_id === report_id);
            result.forEach((doc) => {
               reports.push({
                  'id': doc.id,
                  'email': doc.data().email,
                  'index': doc.data().index,
                  'status': doc.data().status,
                  'inv_id': doc.data().inv_id,
                  'report_id': doc.data().report_id
               });
            });
            resolve(reports);
         }).catch((err) => {
            reject(err);
         })
      });
   },

   fetchInvitationReport(id) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         let reports = [];
         db.collection('reports').get().then((querySnapshot) => {
            let result = querySnapshot.docs.filter((snap) => snap.id === id);
            result.forEach((doc) => {
               reports.push({
                  'id': doc.id,
                  'uid': doc.data().uid,
                  'type': doc.data().type,
                  'user': doc.data().user,
                  'email': doc.data().email,
                  'source': doc.data().source,
                  'fullpage': doc.data().fullpage,
                  'source_id': doc.data().source_id,
                  'sign_font': doc.data().sign_font,
                  'sign_sign': doc.data().sign_sign,
                  'sign_name': doc.data().sign_name,
                  'blockchain': doc.data().blockchain,
                  'created_at': doc.data().created_at,
                  'activate_js': doc.data().activate_js,
                  'captured_file': doc.data().captured_file,
                  'all_signatures': doc.data().all_signatures,
                  'transaction_hash': doc.data().transaction_hash,
                  'captured_file_id': doc.data().captured_file_id,
                  'captured_file_hash': doc.data().captured_file_hash
               });
            });
            resolve(reports[0]);
         }).catch((err) => {
            reject(err);
         })
      });
   },

   deleteReport(id) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         db.collection('reports').doc(id).delete().then((res) => {
            resolve(res);
         }).catch((err) => {
            reject(err);
         })
      });
   },

   updateReport(report_id, source_id, source_url) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         db.collection('reports').doc(report_id).update({
            captured_file: source_url,
            captured_file_id: source_id
         }).then(() => {
            resolve(true);
         }).catch((err) => {
            reject(err);
         })
      });
   },

   updateReportAllSignaturesAsComplete(report_id) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         db.collection('reports').doc(report_id).update({
            all_signatures: 'COMPLETE'
         }).then(() => {
            resolve(true);
         }).catch((err) => {
            reject(err);
         })
      });
   },

   updateInvitation(id) {
      return new Promise((resolve, reject) => {
         const db = firebase.firestore();
         db.collection('invitations').doc(id).update({
            status: 'done',
         }).then(() => {
            resolve(true);
         }).catch((err) => {
            reject(err);
         })
      });
   }
};

export default firebaseService;